define('src/shim/backbone.plugins',[
    "src/shim/backbone",
    "epoxy",
], function(Backbone) {
    return Backbone;
});

